<style scoped>
  .top-margin {
    margin-top: 150px;
  }
</style>

<template>
<v-card
  class="mx-auto top-margin"
  max-width="400"
>
  <v-list
    two-line
    flat
    nav
  >
    <v-card-title>Top Videos of Reddit</v-card-title>
    <v-list-item-group>

      <v-divider></v-divider>
      <v-list-item href="/r/aww/comments/90bu6w/heat_index_was_110_degrees_so_we_offered_him_a/">
        <v-list-item-avatar size=50>
          <v-img src="https://b.thumbs.redditmedia.com/wMY3nkccnU7gRcXDLnGHshGnIic1rHgchauFoEpZM-A.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Heat index was 110 degrees so we offered him a cold drink. He went for a full body soak instead</v-list-item-title>
          <v-list-item-subtitle>r/aww</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      
      <v-list-item href="/r/thanosdidnothingwrong/comments/8x2pyo/reddit_thanos_has_a_message_for_you/">
        <v-list-item-avatar size=50>
          <v-img src="https://b.thumbs.redditmedia.com/o3JK-fZEOFLOPG2eZj3Qp4LXkaLYZ6Cs7R40E3t19oo.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Reddit, Thanos has a message for you...</v-list-item-title>
          <v-list-item-subtitle>r/thanosdidnothingwrong</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item href="/r/funny/comments/dhfigp/irish_man_leaves_funny_recording_for_his_funeral/">
        <v-list-item-avatar size=50>
          <v-img src="https://b.thumbs.redditmedia.com/TmOc1Qjlb-6ieN6CfEyYysVPE4boA_bsDi4fiPaemaA.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Irish man leaves funny recording for his funeral!</v-list-item-title>
          <v-list-item-subtitle>r/funny</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item href="/r/funny/comments/7qp34o/im_that_sibling/">
        <v-list-item-avatar size=50>
          <v-img src="https://b.thumbs.redditmedia.com/RRe1msTsMmAnfAB1nGc3W4qC-6p4CRwUIG37Vrc96DI.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>I'm that sibling</v-list-item-title>
          <v-list-item-subtitle>r/funny</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item href="/r/funny/comments/dq8gm7/my_son_happened_across_a_herd_of_other_trex_last/">
        <v-list-item-avatar size=50>
          <v-img src="https://b.thumbs.redditmedia.com/Bhx-IdA_Ns24xQn5RpnWcJX_otzbQNSOcNVtwKvyF6g.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>My son happened across a herd of other t-rex last night and they asked him to join them.</v-list-item-title>
          <v-list-item-subtitle>r/funny</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

    </v-list-item-group>
  </v-list>
</v-card>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
